import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template"
import {filterUser_template} from "./filterUser_template";
import {filterArticle_template} from "./filterArticle_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";

declare var ko: any;

export class articles30DayPerformance_template extends vnTemplate{

    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected dateFilter: filterDate_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected contentTypesFilter : multipleSelector_template;
    protected filterUser: filterUser_template;
    protected filterArticle: filterArticle_template;
    protected filterPreset: filterPreset_template;

    protected getTemplateHtml(): string{

        return `
            <div class="sub-header filter-preset w-justify ">

                    ` + this.filterPreset.getHtmlBuild() + `
            </div>

            <div class="sub-header w-justify">
                
                <div class=" w-justify">
                    <div class="w-left">
                        
                        ` + this.dateFilter.getHtmlBuild() + `
                        ` + this.networkCategoriesFilter.getHtmlBuild() + `
                        ` + this.contentTypesFilter.getHtmlBuild() + `
                        ` + this.filterUser.getHtmlBuild() + `
                        ` + this.filterArticle.getHtmlBuild() + `
                    </div>
                    
                </div>
                
            </div>
            
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-content_types"></div>
                   <div id="selected-network_categories"></div>
                </div>   
            </div>
                  
            <div class="list-header w-justify" >
                
                <div class="w-right">
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
                
            </div>
            
            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'datePublish') }, css: { 'list-sort-desc': orderByAndDirection()=='datePublish_DESC', 'list-sort-asc': orderByAndDirection()=='datePublish_ASC' }">Date Published</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Article Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'author') }, css: { 'list-sort-desc': orderByAndDirection()=='author_DESC', 'list-sort-asc': orderByAndDirection()=='author_ASC' }">Author</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'networkCategory') }, css: { 'list-sort-desc': orderByAndDirection()=='networkCategory_DESC', 'list-sort-asc': orderByAndDirection()=='networkCategory_ASC' }">Network Category</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentType') }, css: { 'list-sort-desc': orderByAndDirection()=='contentType_DESC', 'list-sort-asc': orderByAndDirection()=='contentType_ASC' }">Content Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'daysCompletion') }, css: { 'list-sort-desc': orderByAndDirection()=='daysCompletion_DESC', 'list-sort-asc': orderByAndDirection()=='daysCompletion_ASC' }">Days Completion</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'pageViews') }, css: { 'list-sort-desc': orderByAndDirection()=='pageViews_DESC', 'list-sort-asc': orderByAndDirection()=='pageViews_ASC' }">Page Views In Initial 30 Days</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: articles">
                        
                        <tr>
                            <td><span data-bind="text: datePublish.substring(0, 10)"></span></td>
                           <td><span data-bind="text: title"></span></td>
                            <td data-bind=" if: author"><span data-bind="text: author"></span></td>
                            <td><span data-bind="text: networkCategory"></span></td>
                            <td><span data-bind="text: contentType"></span></td>
                            <td><span data-bind="text: daysCompletion + '/30'"></span></td>
                            <td><span data-bind="text: pageViews"></span></td>

                        </tr>
                        
                    </tbody>
                </table>
            </div>    
            
            `;
    }

    protected initPartial(): void{

        //this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)

        let currentDate = new Date();
        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.setDateRange(
            new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 30, 0, 0, 0),
            new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59),
        );

        this.networkCategoriesFilter = new multipleSelector_template("networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setFilterContainerClass('margin-neg');
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.contentTypesFilter = new multipleSelector_template("contentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.contentTypesFilter.setLabel("content types");
        this.contentTypesFilter.setFilterContainerClass('margin-neg');
        this.contentTypesFilter.setTagContainerId('selected-content_types');
        this.contentTypesFilter.setTagContainerCaption('Selected content types:');

        this.filterUser = new filterUser_template("filterUser", this.getTemplateViewModel(), this.caller);
        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);

        //False by default, then set to true later on
        this.setCanSearchUsers(false);

        this.filterPreset.getTemplateViewModel().searchPresetType('30DayPerformance');
    }

    protected getTemplateName(): string{
        return "articles30DayPerformance-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return{
            orderBy: ko.observable("datePublish"),
            orderByDirection: ko.observable("DESC"),
            articles: ko.observableArray([]),
            orderByAndDirection: ko.observable("datePublish_DESC"),
            onClickReorder: function (value, data, event){
                huit_neuf_this.onClickReorder(value, data, event);
            }
        };

    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }

    public getViewModelForRequest(){

        return {
            orderBy : this.viewModel.list.orderBy
            , orderByDirection : this.viewModel.list.orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            , searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName()
            , searchPresetType: '30DayPerformance'
            , filters      : {
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems,
                contentTypes: this.getTemplateViewModel().contentTypesFilter.selectedItems,
                idAuthor: this.getTemplateViewModel().filterUser.idUser,
                idArticle: this.getTemplateViewModel().filterArticle.idArticle,
                articleTitle: this.getTemplateViewModel().filterArticle.article
            },
        }
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.articlesListReorder();
    }

    public setArticles(articles: Array<{ datePublish: string, title: string, author: string, networkCategory: string, contentType: string, pageViews: string}>): void {

        for (let p of articles) {

            p['pageViews'] = Number(p.pageViews).toLocaleString(undefined, {minimumFractionDigits: 0});
        }
        this.getTemplateViewModel().articles(articles);
    }

    public setResultInfo(nbResults, nbPages, execTime ){

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setNetworkCategoriesFilterItems(items){

        items.unshift({'id': 0, 'name' : 'no network categories'});
        this.networkCategoriesFilter.setItems(items);
    }

    public setContentTypesFilterItems(items){

        items.unshift({'id': 0, 'name' : 'no post types'});
        this.contentTypesFilter.setItems(items);
    }

    public setUsersFilter(users) {

        this.getTemplateViewModel().filterUser.users(users);
    }

    public setArticlesFilter(articles) {

        this.getTemplateViewModel().filterArticle.articles(articles);
    }

    public setCanSearchUsers(canSearchUsers: boolean){

        this.filterUser.setIsVisible(canSearchUsers);
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            // date filters.
            if(urlParams.dateFilterType){
                this.dateFilter.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if(urlParams.startDateRange || urlParams.endDateRange){

                this.dateFilter.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }

            if(urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            this.setFilterSelectedItems(this.contentTypesFilter, urlParams.contentTypes);
            this.setFilterSelectedItems(this.networkCategoriesFilter, urlParams.networkCategories);

            let title = urlParams.articleTitle;
            if(urlParams.idArticle && urlParams.articleTitle){

                title = urlParams.articleTitle.replaceAll("+", " ");
            }
            this.setArticlePresetFilter(this.filterArticle, urlParams.idArticle, title);
        }
    }

    public setSearchPresets(presets){
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){
        this.filterPreset.addCreatedPresetToList(response);
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    private setArticlePresetFilter(filterArticle: filterArticle_template, idArticle?: number, title?: string): void {

        filterArticle.getTemplateViewModel().idArticle(idArticle);
        filterArticle.getTemplateViewModel().article(title);
    }

    private setDateFilters(startDate, endDate) {
        if(startDate){
            startDate = new Date(startDate.replace(/-/g, '\/'));
        }
        if(endDate){
            endDate = new Date(endDate.replace(/-/g, '\/'));
        }

        this.dateFilter.setDateRange(startDate, endDate);
    }

    public setDefaults(){

        // date filters.
        this.dateFilter.getTemplateViewModel().selectedFilter("range");
        this.dateFilter.setRange("-30d", null);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/articles30DayPerformance_template.ts